// extracted by mini-css-extract-plugin
export var divider = "_g3-7";
export var itemsToggle = "_g3-8";
export var mergeModal = "_g3-1";
export var optionCard = "_g3-4";
export var radioGroup = "_g3-6";
export var radioOption = "_g3-0";
export var selected = "_g3-5";
export var shipmentOptions = "_g3-2";
export var tableOptions = "_g3-3";